import classnames from 'classnames';
import React, { ChangeEvent } from 'react';
import TextInput from './TextInput';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';

type InputSearchProps = {
  label?: string;
  value: string;
  reset: () => void;
  onChange: (value: string) => void;
  placeholder: string;
  simple?: any;
  labelClass?: string;
  extraClass?: string;
  inputClassName?: string;
  className?: string;
  onClick?: () => void;
};

const InputSearch = (props: InputSearchProps) => {
  const { label, placeholder, value, reset, onChange, onClick } = props;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (onClick) {
        onClick();
      }
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleClick();
  };

  const containerClasses = classnames('space-x-4', 'p-4', 'flex', 'flex-grow', {
    'justify-left rounded-md shadow-inner': props.simple
  });

  return (
    <div className="charts-search rounded-tr-none mb-4 ev-sm:mb-6 ev-sm:flex">
      <form className="flex flex-wrap w-full" onSubmit={(e) => handleOnSubmit(e)}>
        <div className={containerClasses}>
          <div className="flex">
            <TextInput
              name="search"
              label={label}
              value={value}
              reset={reset}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              placeholder={placeholder}
              labelClass={`font-bold text-base text-ev-navy-blue ${props.labelClass}`}
              extraClass={`px-0 min-w-0 mb-0 ${props.extraClass}`}
              inputClassName={`rounded-none rounded-l-md h-10 highed-field-input font-medium hover:bg-ev-baby-blue-2 hover:border-ev-baby-blue-2 focus:border-none  hover:border-b cursor-pointer ring-ev-dark-purple border-b border-solid border-black border-opacity-10  ${props.inputClassName}`}
            />
            <PrimaryButton
              text={<i className="fa fa-search" />}
              buttonColor={ButtonColor.NavyBlue}
              buttonType={ButtonType.InputButton}
              onClick={handleClick}
            />
          </div>
        </div>
        {!props.simple && <div className="p-4 gap-x-2 ev-md:flex hidden"></div>}
      </form>
    </div>
  );
};

export default InputSearch;
